// extracted by mini-css-extract-plugin
module.exports = {"container":"VirtualScommesseWrapper_container__d0R0o","mainTitle":"VirtualScommesseWrapper_mainTitle__ZZjzR","estesa":"VirtualScommesseWrapper_estesa__117Bo"};